import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ml-administrator-contact-information',
  template: `
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      class="container"
      fxLayoutGap="8px"
    >
      <mat-icon style="color: white" svgIcon="contact_phone"></mat-icon>
      <div class="mat-body-2">Mike Dickes: +352 621 401 100</div>
    </div>
  `,
  styleUrls: ['./administrator-contact-information.component.scss']
})
export class AdministratorContactInformationComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
